export default __webpack_public_path__ + "static/media/logo.5bf903b0.png";